/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
// import { Column, Container, Row } from '../../../../styles/Grid';

// import DotComponent from '../../../ui/DotComponent';
import * as Styles from './index.style';
// import Spacer from '../../../ui/Spacer';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import { get } from 'lodash';
// import iconSvg from './icon.svg';
// import { Select } from '../../../ui/Form';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { Icon } from '../../../ui/Icon';
import DotComponent from '../../../ui/DotComponent';

class ScrollerBlock extends SafePureComponent {
  getItem = SelectedFeature => {
    return SelectedFeature.map((item, index) => {
      const IconVal = get(item, 'fields.Icon', {});
      const Text = get(item, 'fields.Text.value', '');
      // if (index > 4) return null;
      return (
        <li key={index}>
          <span className="img_icon">
            {IconVal.value && IconVal.value.src != null && (
              <Image field={IconVal} editable={false} />
              // <img src={item.fields.Icon.value.src} alt="icon" />
            )}
          </span>
          <span>{Text}</span>
        </li>
      );
    });
  };

  componentDidMount = () => {
    setTimeout(() => {
      this.props.setScrollShadowCss();
    }, 500);
  };

  render() {
    const { isDarkMode, fields } = this.props;

    const SelectedFeatures = get(fields, 'SelectedFeatures', []);
    const FeaturesLearnMoreLink = get(
      fields,
      'FeaturesLearnMoreLink.value.href',
      '',
    );
    const FeaturesLearnMoreLinkText = get(
      fields,
      'FeaturesLearnMoreLinkText.value',
      '',
    );
    const FeaturesSectionTitle = get(fields, 'FeaturesSectionTitle.value', '');
    // console.log('zzz fields >> 0', fields);
    return (
      <div
        css={[
          Styles.commonCss,
          isDarkMode ? Styles.DarkModeCss : Styles.LightModeCss,
        ]}
      >
        <div className="scroll_bannerpart">
          <h2>
            {FeaturesSectionTitle}
            <DotComponent />
          </h2>

          <ul>{this.getItem(SelectedFeatures)}</ul>

          {/* {FeaturesLearnMoreLink && (
            <a className="learnmore" href={FeaturesLearnMoreLink}>
              <span>{FeaturesLearnMoreLinkText}</span>
              <span>
                <Icon name="chevron-right" />
              </span>
            </a>
          )} */}
        </div>
        {/* <div className="shadow_bg"></div> */}
      </div>
    );
  }
}

export default ScrollerBlock;
